import React from 'react';
import { Player } from '../classes/Player';
import { Round } from '../classes/Round';
import { RoundBlackCard } from '../classes/RoundBlackCards';
import { RoundPhase } from '../constants/RoundPhase';
import { cutText } from '../utils/TextsUtils';

interface GameRoomPlayerInterface {
    player: Player;
    round: Round;
    roundBlackCards: RoundBlackCard[];
    roundPhase: RoundPhase;
    score: number;
    shouldShowHand: boolean;
};

function GameRoomPlayer({player, round, roundBlackCards, roundPhase, score, shouldShowHand}: GameRoomPlayerInterface) {
    const hand = require("../images/hand.png");
    const judgeHammerWhite = require("../images/judgeHammerWhite.png");
    const redCard = require("../images/redCard.png");
    const playerImage = require("../images/avatars/" + player.image + ".png");

    const getBackgroundColor = () => {
        return round.criminal === player.id ? "#D30000" : "black";
    }

    const getPointsText = () => {
        return score === 1 ? "pt" : "pts";
    }

    const hasPlayed = () => {
        const idx = roundBlackCards.findIndex((r) => r.player === player.id);
        if (idx === -1) { // initially
            return false;
        }

        if (roundBlackCards[idx].blackCardIdx === -1) { // after each round, when we set blackCardIdx to -1
            return false;
        }
        return true;
    }

    const isWaiting = () =>{
        return player.id !== round.judge && roundPhase === RoundPhase.waitForOthersToPlay && !hasPlayed();
    }

    return (
        <div className="gameRoomPlayerWrapper">
            <div className="gameRoomPlayerTopWrapper">
                {shouldShowHand && <img className="gameRoomPlayerHand" src={hand} alt="hand"/>}
                {!shouldShowHand && <div className="gameRoomPlayerWaiting" style={{color: `${isWaiting() ? "#D30000" : "black"}`}}>WAITING...</div>}
            </div>
            <div className="gameRoomPlayerPlayerWrapper" style={{backgroundColor: getBackgroundColor()}}>
                <img className="gameRoomPlayerImage" src={playerImage} alt="player avatar"/>
                <div className="gameRoomPlayerName">{cutText(player.name, 10)}</div>
                <div className="gameRoomPlayerScoreWrapper">
                    <div className="gameRoomPlayerScore">{score}</div>
                    <div className="gameRoomPlayerPoints">{getPointsText()}</div>
                </div>
            </div>
            <div className="gameRoomPlayerJudgeWrapper">
                {round.judge === player.id && <img className="gameRoomPlayerJudgeHammer" src={judgeHammerWhite} alt="judge"/>}
                {round.judge === player.id && round.redCardIdx >= 0 && <img className="gameRoomPlayerRedCard" src={redCard} alt="red card"/>}
            </div>
        </div>
    );
};

export default GameRoomPlayer;